export const INTEGRATION_CONNECTOR_TYPES = [
    'ga4',
    'gsc',
    'pagespeed',
    'google_ads',
    'brevo',
    'wordpress',
];
export const INTEGRATION_CONNECTOR_LABELS = {
    ga4: 'Google Analytics 4',
    gsc: 'Google Search Console',
    pagespeed: 'PageSpeed Insights',
    google_ads: 'Google Ads',
    brevo: 'Brevo',
    wordpress: 'WordPress',
};
//# sourceMappingURL=integrationConnectors.js.map